import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onUnmounted } from 'vue';
import Avatar from '../common/Avatar.vue';
import { useI18n } from '../../locales';
import EnterRoomIcon from '../common/icons/EnterRoomIcon.vue';
import SvgIcon from '../common/base/SvgIcon.vue';
import TuiButton from '../common/base/Button.vue';
import {
  TUIConferenceInvitationManagerEvents,
  TUIInvitation,
  TUIInvitationRejectedReason,
  TUIRoomInfo,
} from '@tencentcloud/tuiroom-engine-js';
import { roomService } from '../../services/index';

export default /*#__PURE__*/_defineComponent({
  __name: 'InvitationNotification',
  emits: ['join-conference'],
  setup(__props, { emit: emits }) {

const invitationInfo = ref({
  userId: '',
  userName: '',
  avatarUrl: '',
  roomName: '',
  roomMemberCount: 0,
  roomOwner: '',
  roomId: '',
});
const { t } = useI18n();
const showInvitation = ref(false);



const onReceiveInvitation = (data: {
  roomInfo: TUIRoomInfo;
  invitation: TUIInvitation;
  extensionInfo: string;
}) => {
  const { roomInfo, invitation } = data;
  invitationInfo.value.userId = invitation.inviter.userId;
  invitationInfo.value.userName = invitation.inviter.userName;
  invitationInfo.value.avatarUrl = invitation.inviter.avatarUrl;
  invitationInfo.value.roomName = roomInfo.roomName;
  invitationInfo.value.roomMemberCount = roomInfo.roomMemberCount;
  invitationInfo.value.roomOwner = roomInfo.roomOwner;
  invitationInfo.value.roomId = roomInfo.roomId;
  setInvitationDisplay(true);
};

const handleEnterRoom = () => {
  const { roomId } = invitationInfo.value;
  roomService.conferenceInvitationManager.accept({ roomId });
  setInvitationDisplay(false);
  emits('join-conference', {
    roomId,
    roomParam: {
      isOpenCamera: false,
      isOpenMicrophone: true,
    },
  });
};

const handleRejectInvitation = () => {
  const { roomId } = invitationInfo.value;
  roomService.conferenceInvitationManager.reject({
    roomId,
    reason: TUIInvitationRejectedReason.kRejectToEnter,
  });
  setInvitationDisplay(false);
};

const onInvitationTimeout = () => {
  setInvitationDisplay(false);
};

const onInvitationHandledByOtherDevice = () => {
  setInvitationDisplay(false);
};

const setInvitationDisplay = (options: boolean) => {
  showInvitation.value = options;
};

onMounted(() => {
  roomService.conferenceInvitationManager.on(
    TUIConferenceInvitationManagerEvents.onReceiveInvitation,
    onReceiveInvitation
  );
  roomService.conferenceInvitationManager.on(
    TUIConferenceInvitationManagerEvents.onInvitationTimeout,
    onInvitationTimeout
  );
  roomService.conferenceInvitationManager.on(
    TUIConferenceInvitationManagerEvents.onInvitationHandledByOtherDevice,
    onInvitationHandledByOtherDevice
  );
});
onUnmounted(() => {
  roomService.conferenceInvitationManager.off(
    TUIConferenceInvitationManagerEvents.onReceiveInvitation,
    onReceiveInvitation
  );
  roomService.conferenceInvitationManager.off(
    TUIConferenceInvitationManagerEvents.onInvitationTimeout,
    onInvitationTimeout
  );
  roomService.conferenceInvitationManager.off(
    TUIConferenceInvitationManagerEvents.onInvitationHandledByOtherDevice,
    onInvitationHandledByOtherDevice
  );
});

return { __sfc: true,invitationInfo, t, showInvitation, emits, onReceiveInvitation, handleEnterRoom, handleRejectInvitation, onInvitationTimeout, onInvitationHandledByOtherDevice, setInvitationDisplay, Avatar, EnterRoomIcon, SvgIcon, TuiButton }
}

})